export const GIFT_CARD_PRESET_AMOUNTS = [2500, 5000, 7500, 10000];
export const GIFT_CARD_MIN_DOLLARS = 10;
export const GIFT_CARD_MAX_DOLLARS = 500;
export const GIFT_CARD_MESSAGE_MAX_LENGTH = 300;

/** Gift card codes are 12 chars from this alphabet, optionally dash-separated. */
export const GIFT_CARD_CODE_REGEX = /^[HMN34P67R9TWCXYF]{6}-?[HMN34P67R9TWCXYF]{6}$/i;

/** "yyyy-MM-dd" → a local Date (no UTC shift). */
export function parseSendOn(sendOn: string): Date {
  const [y, m, d] = sendOn.split("-").map(Number);
  return new Date(y ?? 0, (m ?? 1) - 1, d ?? 1);
}

export function formatGiftCardSendOn(sendOn: string | null | undefined) {
  if (!sendOn) return "Emailed right after checkout";
  return `Emails on ${parseSendOn(sendOn).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
  })}`;
}
